import { gql } from '@apollo/client';

const UPDATE_PRACTITIONER = gql`
  mutation UpdatePractitioner($id: ID!, $practitioner: PractitionerInput!) {
    updatePractitioner(id: $id, practitioner: $practitioner) {
      practitioner {
        id
        prenuvoId

        salutation
        firstName
        lastName
        profession
        title

        licenses {
          edges {
            node {
              licenseType
              licenseJurisdiction
              licenseNumber
            }
          }
        }

        contact {
          phoneNumber
          faxNumber
          emailAddress
        }
      }
    }
  }
`;

const ADD_PRACTITIONER = gql`
  mutation AddPractitioner($practitioner: PractitionerInput!) {
    createPractitioner(practitioner: $practitioner) {
      practitioner {
        id

        salutation
        firstName
        lastName
        profession
        title

        licenses {
          edges {
            node {
              licenseType
              licenseJurisdiction
              licenseNumber
            }
          }
        }

        contact {
          phoneNumber
          faxNumber
          emailAddress
        }
      }
    }
  }
`;

export const practitionerMutations = {
  ADD_PRACTITIONER,
  UPDATE_PRACTITIONER,
};
